import { AnalyticsKycEvent } from '@accountFederation/modules/idCardVerification/analytics/idVerificationAnalytics';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export function sendIdCardVerificationEventEntry() {
    AnalyticsSDK.getInstance()
        .log(AnalyticsKycEvent.VerifyIdentityEntry);
}
